var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{staticClass:"mt-3"},[_c('iframe',{attrs:{"src":_vm.url,"frameborder":"0","type":"application/pdf","width":"100%","height":"800px"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }